import { Tooltip } from "@twinkltech/curriculum-architect-component-library";

import { StyledTag } from "../StyledTag/StyledTag";

export const TagList = ({
  maxCount,
  tags,
  variant,
  ...props
}: {
  tags: Set<string>;
  maxCount?: number;
  variant?: "default" | "dark";
} & Omit<React.ComponentProps<"ul">, "children">) => {
  const displayedTags =
    maxCount !== undefined
      ? Array.from(tags).slice(0, maxCount)
      : Array.from(tags);

  const hiddenTags =
    maxCount !== undefined ? Array.from(tags).slice(maxCount) : [];

  const styledTagProps = {
    size: "sm" as const,
    variant: "default-alt" as const,
    className: variant === "dark" ? "border-transparent" : "bg-white",
  };

  return (
    <ul className="flex gap-2 flex-wrap" {...props}>
      {displayedTags.map((tag) => (
        <li key={tag}>
          <StyledTag {...styledTagProps}>{tag}</StyledTag>
        </li>
      ))}
      {hiddenTags.length > 0 && (
        <li>
          <Tooltip
            description={
              <ul className="flex flex-col gap-1">
                {hiddenTags.map((tag) => (
                  <li key={tag}>{tag}</li>
                ))}
              </ul>
            }
            tooltipClasses="p-1"
          >
            <StyledTag {...styledTagProps}>+{hiddenTags.length}</StyledTag>
          </Tooltip>
        </li>
      )}
    </ul>
  );
};
